import type { StoreHoursEntry } from './types'

export const storeHours: readonly StoreHoursEntry[] = [
  {
    label: 'Monday–Friday',
    days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '09:00',
    closes: '18:00',
    display: '9:00 AM–6:00 PM',
  },
  {
    label: 'Saturday',
    days: ['Saturday'],
    opens: '09:00',
    closes: '13:00',
    display: '9:00 AM–1:00 PM',
  },
  {
    label: 'Sunday',
    days: ['Sunday'],
    opens: null,
    closes: null,
    display: 'Closed',
  },
]

